import { Grid } from '@mui/material'

import { Media } from './Media'

import type React from 'react'
import type { GridProps } from '@mui/material'
import type { MediaList as MediaListProps } from '@/gen/sanity/schema'

export const MediaList: React.FC<MediaListProps & GridProps> = ({ items, internalName, _type, ...gridProps }) => {
  return (
    <Grid container columnSpacing={3} className="MediaList-root" {...gridProps}>
      {items?.map((item) => (
        <Grid item key={item._key}>
          <Media {...item} />
        </Grid>
      ))}
    </Grid>
  )
}
